import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import "./User.css";
import userImage from "../images/spaGirl.png";
import { updateProfileUsername } from "../api/auth";

function User() {
  const location = useLocation();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState(() => location.state || {});
  const [errorMessage, setErrorMessage] = useState("");
  const [isChecking, setIsChecking] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((values) => ({ ...values, [name]: value }));
    if (errorMessage) setErrorMessage("");
  };

  async function handleNextClick() {
    const raw = (inputs.username || "").trim();
    const name = raw; 

    if (!name) return setErrorMessage("Please enter a username");
    if (!/^[A-Za-z0-9_]{2,64}$/.test(name)) {
      return setErrorMessage("Username must be 2~64 chars (letters, numbers, underscores).");
    }

    setIsChecking(true);

    try {
      await updateProfileUsername(name);
      setErrorMessage("");
      navigate("/UploadPhoto", { state: { ...inputs, username: name } });
    } catch (e) {
      const status = e?.status ?? e?.response?.status;
      const data = e?.data ?? e?.response?.data;
      const detail = data?.detail ?? data;

      let msg =
        (detail && detail.username && (Array.isArray(detail.username) ? detail.username[0] : String(detail.username))) ||
        detail?.message ||
        e?.message ||
        "Unable to save username right now. Please try again.";

      if (status === 401) {
        msg = "Session expired. Please log in again.";
      }

      setErrorMessage(msg);
    } finally {
      setIsChecking(false);
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
  };

  const handleBackClick = () => {
    navigate("/About", { state: { ...inputs } });
  };

  const isNextDisabled = isChecking || !(inputs.username || "").trim();

  return (
    <div className="user-login-container">
      <div className="login-box">
        <ProgressBar steps={3} currentStep={2} comboType="combo1" />
        <div>
          <img src={userImage} alt="User" className="user-image" />
          <p className="h4 fw-bold my-4">Pick your username</p>
          <p>This is the name fellow users will know you by</p>

          {errorMessage && (
            <div className="alert alert-danger mb-3" role="alert">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="my-3">
              <input
                type="text"
                name="username"
                placeholder="Enter username"
                value={inputs.username || ""}
                onChange={handleChange}
                required
                className="form-control"
                aria-invalid={!!errorMessage}
                aria-describedby={errorMessage ? "username-error" : undefined}
              />
              {errorMessage && (
                <div id="username-error" className="visually-hidden">
                  {errorMessage}
                </div>
              )}
            </div>

            <div className="row my-4 gx-2">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-light-gray w-100"
                  onClick={handleBackClick}
                >
                  Go Back
                </button>
              </div>
              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary text-white w-100"
                  onClick={handleNextClick}
                  disabled={isNextDisabled}
                >
                  {isChecking ? "Saving..." : "Next"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default User;
